import React, { useEffect, useCallback, useState } from 'react';
import { useParams } from "react-router-dom";

import { useGlobalContext } from '../../context/GlobalContext';
import { API_URL } from '../../../actions';
import SelectMedia from '../medias/SelectMedia';
import MetaSeo from '../../partials/MetaSeo';

import { getMediasAction } from '../../../actions/mediasActions';
import { getCompanyAction } from '../../../actions/companiesActions';
import { getSeoAction, updateSeoAction } from '../../../actions/themeActions';

import '../../../styles/pages-sites.scss';

const SEO_PAGES = [
  { key: 'projects', label: 'Projets' },
  { key: 'news', label: 'Actualités' },
  { key: 'medias', label: 'Médiathèque' },
  { key: 'legals', label: 'Mentions légales' },
  { key: 'contact', label: 'Contact' }
];

export default function SeoPages({ setDisplayNavBar, setDisplaySelectLang, setDisplaySiteNav, setActivePage, theme, lang }) {
  const param = useParams();
  const [context, dispatch] = useGlobalContext();

  const [seoPages, setSeoPages] = useState({});
  const [seoDefaultImage, setSeoDefaultImage] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [publishIsLoading, setPublishIsLoading] = useState(false);
  const [displaySelectMedia, setDisplaySelectMedia] = useState(false);

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch, param.companyId);
    getMediasAction(dispatch, param.companyId);
  }, [dispatch, param.companyId]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true);
    setActivePage("seo-pages");
    getCompany();
    return () => {
      setDisplaySelectLang(false);
      setIsMounted(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSeoAction(dispatch, param.companyId, lang);
    setIsMounted(false);
    // eslint-disable-next-line
  }, [lang]);

  useEffect(() => {
    if (context.theme.seo) {
      setSeoPages(context.theme.seo.seoPages || {});
      setSeoDefaultImage(context.theme.seo.seoDefaultImage || null);
      setIsMounted(true);
    }
    // eslint-disable-next-line
  }, [context.theme.seo]);

  useEffect(() => {
    if (context.theme && context.theme.message === 'Theme successfully updated') {
      setPublishIsLoading(false);
      dispatch({ type: 'MESSAGE_PAGE', payload: null });
      dispatch({
        type: 'SET_TOAST',
        payload: { message: "Les métadonnées SEO ont été enregistrées", type: "success" }
      });
    }
    // eslint-disable-next-line
  }, [context.theme.message]);

  function handleSeoPageChange(pageKey, seoData) {
    setSeoPages(prev => ({ ...prev, [pageKey]: seoData }));
  }

  function handleDefaultImageSelect(value) {
    if (value && value.length > 0) {
      setSeoDefaultImage(value[0]);
    }
  }

  function renderDefaultImage() {
    if (!seoDefaultImage) return null;
    const imageId = seoDefaultImage?._id || seoDefaultImage;
    const found = context?.medias?.mediasList?.find(item => item._id === imageId);
    if (found) {
      return <img src={API_URL + '/' + found.path} alt="default seo" style={{ maxWidth: 300, maxHeight: 160, marginTop: 10 }} />;
    }
    if (seoDefaultImage?.path) {
      return <img src={API_URL + '/' + seoDefaultImage.path} alt="default seo" style={{ maxWidth: 300, maxHeight: 160, marginTop: 10 }} />;
    }
    return null;
  }

  function submitSeo() {
    setPublishIsLoading(true);
    const company = context.companies.company;
    const site = company.type === 'group' ? 'group' : 'subsidiary';
    const themeId = company.theme[lang];

    const obj = {};
    SEO_PAGES.forEach(({ key }) => {
      if (seoPages[key]) {
        obj[`seoPages.${key}.metaTitle`] = seoPages[key].metaTitle || '';
        obj[`seoPages.${key}.metaDescription`] = seoPages[key].metaDescription || '';
        obj[`seoPages.${key}.metaImage`] = seoPages[key].metaImage?._id || seoPages[key].metaImage || null;
      }
    });
    obj['seoDefaultImage'] = seoDefaultImage?._id || seoDefaultImage || null;

    updateSeoAction(dispatch, themeId, site, obj);
    dispatch({ type: 'ERROR_PAGE', payload: null });
    dispatch({ type: 'MESSAGE_PAGE', payload: null });
  }

  return (
    <>
      {isMounted && (
        <div className={`page-container site ${theme}`}>
          <div className="page-content">
            <div className="title-row space-between">
              <div className="flex">
                <div className="title">
                  <h1>Référencement SEO - Pages ({lang})</h1>
                  <div className="bar primary"></div>
                </div>
              </div>
            </div>

            <div className="list-container">
              <div className="list-item transition edit-row">
                <div style={{ padding: 20 }}>
                  <div className="btn-actions-container" style={{ marginBottom: 30 }}>
                    {publishIsLoading ? null : (
                      <button
                        className={`btn primary publish ${theme}-bg`}
                        type="button"
                        onClick={() => submitSeo()}
                      >
                        Publier
                      </button>
                    )}
                  </div>

                  <div style={{ marginBottom: 30, borderBottom: '2px solid #e0e0e0', paddingBottom: 20 }}>
                    <h3>Image SEO par défaut du site</h3>
                    <p style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
                      Cette image sera utilisée pour les pages qui n'ont pas d'image SEO spécifique.
                    </p>
                    <div className="btn-container" style={{ marginBottom: 10 }}>
                      <button
                        type="button"
                        className={`btn primary ${theme}-bg`}
                        style={{ marginRight: 20 }}
                        onClick={() => setDisplaySelectMedia(true)}
                      >
                        Parcourir
                      </button>
                      {seoDefaultImage && (
                        <button
                          type="button"
                          className={`btn primary ${theme}-bg`}
                          onClick={() => setSeoDefaultImage(null)}
                        >
                          Supprimer
                        </button>
                      )}
                    </div>
                    {renderDefaultImage()}
                  </div>

                  {SEO_PAGES.map(({ key, label }) => (
                    <div key={key} style={{ marginBottom: 20, borderBottom: '1px solid #f0f0f0', paddingBottom: 20 }}>
                      <h3>{label}</h3>
                      <MetaSeo
                        seo={seoPages[key]}
                        onChange={(seoData) => handleSeoPageChange(key, seoData)}
                        theme={theme}
                        companyId={param.companyId}
                      />
                    </div>
                  ))}

                  <div className="btn-actions-container" style={{ marginTop: 20 }}>
                    {publishIsLoading ? null : (
                      <button
                        className={`btn primary publish ${theme}-bg`}
                        type="button"
                        onClick={() => submitSeo()}
                      >
                        Publier
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SelectMedia
            displaySelectMedia={displaySelectMedia}
            dispatch={dispatch}
            theme={theme}
            context={context}
            mediaType="image"
            selectedMediaList={seoDefaultImage ? [seoDefaultImage._id || seoDefaultImage] : []}
            companyId={param.companyId}
            isMulti={false}
            handleChange={(value) => handleDefaultImageSelect(value)}
            setDisplaySelectMedia={setDisplaySelectMedia}
          />
        </div>
      )}
    </>
  );
}
